import { extendTheme } from "@chakra-ui/react";

const appTheme = extendTheme({
  colors: {
    primary: {
      100: "#f5e2e4",
      200: "#e8b6ba",
      300: "#db8991",
      400: "#cf5c67",
      500: "#c22f3d",
      600: "#a92634",
      700: "#8f1e2c",
      800: "#751624",
      900: "#5c0f1c",
      DEFAULT: "#802433",
    },
  },
});

export default appTheme;
